import React from "react";
import "./TripReviewNav.scss";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

const TripReviewNav = (props) => {
  console.group("TripReviewNav");
  console.log(props);
  console.groupEnd();
  let showNoEffortReason = true;
  const styles = {
    button: {
      color: "ButtonText",
      fontFamily: "Proximanova Reg, sans-serif",
    },
  };
  if (
    Array.isArray(props.currentTrip.images) &&
    props.currentTrip.images.length > 0
  ) {
    showNoEffortReason = false;
  }

  return (
    <div className="TripReviewNav center" data-testid="TripReviewNav">
      <Link
        className="link"
        to={`${process.env.PUBLIC_URL}/effort-wizard`}
        state={{
          trip_id: props.trip_id,
          currentTrip: props.currentTrip,
          newEffortNr: props.newEffortNr,
        }}
      >
        <Button style={styles.button}>Add Effort</Button>
      </Link>
      {showNoEffortReason && <span>|</span>}
      {showNoEffortReason && (
        <Link
          className="link"
          to={`${process.env.PUBLIC_URL}/no-effort`}
          state={{
            trip_id: props.trip_id,
            client_id: props.client_id,
          }}
        >
          <Button style={styles.button}>No Effort Trip</Button>
        </Link>
      )}
      |
      <Link
        className="link"
        to={`${process.env.PUBLIC_URL}/ivr`}
        state={{
          trip_id: props.trip_id,
          vesselNbr: props.vesselNbr,
        }}
      >
        <Button style={styles.button}>Add IVR</Button>
      </Link>
      {!props.currentTrip.date_land && <span>|</span>}
      {!props.currentTrip.date_land && (
        <Link
          className="link"
          to={`${process.env.PUBLIC_URL}/landing-date`}
          state={{
            trip_id: props.trip_id,
          }}
        >
          <Button style={styles.button}>Add Landing</Button>
        </Link>
      )}
      {props.currentTrip.date_land && <span>|</span>}
      {props.currentTrip.date_land && (
        <Link
          className="link"
          to={`${process.env.PUBLIC_URL}/sales-wizard`}
          state={{
            trip_id: props.trip_id,
          }}
        >
          <Button style={styles.button}>Add Offload</Button>
        </Link>
      )}
      |
      <Link
        className="link"
        to={`${process.env.PUBLIC_URL}/sign-vtr`}
        state={{
          trip_id: props.trip_id,
        }}
      >
        <Button style={styles.button}>Sign</Button>
      </Link>
      |
      <Button style={styles.button} onClick={props.deleteTrip}>
        Delete Trip
      </Button>
    </div>
  );
};

export default TripReviewNav;
